export const formatLanguages = (languages) =>
  languages.map(({ name }) => name).join(', ')
